<template>
    <div class="register-attendance">
        <ui-text-with-select-area title="Registrar atendimento:">
            <template #select>
                <div class="type">
                    <span>Tipo:</span>
                    <ui-select-v2
                        v-model="form.type"
                        item-label="label"
                        return-value="value"
                        size="xs"
                        :data="options.type"
                        :search="false"
                        :show-footer="false"
                        @input="handleMessage"
                    />
                </div>
            </template>

            <template #text>
                <textarea
                    v-model="form.message"
                    :disabled="disabledMessage"
                    placeholder="Digite..."
                    rows="3"
                />
            </template>
        </ui-text-with-select-area>
    </div>
</template>

<script>
	import { uiSelectV2, uiTextWithSelectArea } from '@/components/ui/form'
	import { utilMixin, formMixin, alertMixin, loaderMixin } from '@/mixins'
	import { task } from '@/services/axios'

	const defaultForm = () => ({
		message: '',
		type: null,
		subject: '',
	})

	const defaultOptions = () => ({
		type: [],
	})

	const defaultLoader = () => ({
		types: false,
	})

	export default {
		name: 'ui-nugget-historical-form',

		components: {
			uiSelectV2,
			uiTextWithSelectArea,
		},

		mixins: [utilMixin, formMixin, alertMixin, loaderMixin],

		props: {
			value: {
				type: Object,
				required: true,
			},

			fetchList: {
				type: Object,
				default: () => ({})
			},

			nuggetId: {
				type: [String, Number],
				default: ''
			}
		},

		data() {
			return {
				form: { ...defaultForm() },
				options: { ...defaultOptions() },
				loader: { ...defaultLoader() },
				nuggetName: 'nugget-historical-form',
			}
		},

		computed: {
			disabledMessage() {
				return !this.$mx_hasValue(this.form.type)
			},

			nuggetTotalName() {
				return this.nuggetName + (this.nuggetId ? '-' + this.nuggetId : '')
			},
		},

		watch: {
			options: {
				deep: true,
				handler(newValue) {
					this.$emit('update:fetchList', newValue)
				},
			},

			form: {
				deep: true,
				handler(newValue) {
					this.$emit('input', newValue)
				},
			},

			'form.type'() {
				if (this.$mx_hasValue(this.form.type))
					this.form.subject =
						'Registro de Atendimento: ' + this.historicalTypeTitle(this.form.type)
				else this.form.subject = ''
			},
		},

		mounted() {
			this.$root.$on(this.nuggetTotalName, async (payload) => {
				this.$mx_setLoader('types', true)
				if (!this.options.type.length) this.options.type = await this.getHistoricalTypes()
				this.$mx_setLoader('types', false)

				if (payload) {
					const { message, type } = payload
					if (message) this.form.message = message
					if (type) this.form.type = type
				}
			})

			this.$root.$on('clean--' + this.nuggetTotalName, () => {
				this.form = { ...defaultForm() }
			})
		},

		beforeDestroy() {
			this.$root.$off(this.nuggetTotalName)
			this.$root.$off('clean--' + this.nuggetTotalName)
		},

		methods: {
			handleMessage(id) {
				if (!this.$mx_hasValue(id)) this.form.message = ''
			},

			async getHistoricalTypes() {
				try {
					const types = await task.getAll('types', null)
					return [...types.data[0].fields]
				} catch (error) {
					return []
				}
			},

			historicalTypeTitle(type) {
				if (type) return this.options.type.find((his) => his.value == type).label
				else return ''
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
